<template>
  <div>
    <b-card class="mb-2 pa-1">
      <b-card-text>
        <BaseBForm
            ref="formSearch"
            :model="data"
        />
        <b-btn
            class="ml-auto mt-2 white--text"
            depressed
            variant="primary-sub1"
            @click="this.handleSearch"
        >
          Αναζήτηση
        </b-btn>
      </b-card-text>
    </b-card>
    <hr>
  </div>
</template>

<script>

import BaseBForm from "@/components/base/BaseBForm.vue";

export default {
  name: "BaseΒFilter",
  components: {BaseBForm},
  props: {
    search: Boolean,
    searchFields: Object,
    valid: Object
  },
  data() {
    return {
      modalData: {},
    };
  },

  computed: {
    data() {
      return this.modalData
    },
  },

  watch: {},
  async created() {
    // this.searchForm = {}
    // this.searchFields.searchFields().fields.forEach(row => {
    //   this.searchForm[row.key] = ""
    //
    // })
    // return this.searchForm
    this.modalData.form = {...this.searchFields.model?.form}
    this.modalData.fields = this.searchFields.fields
    this.modalData.validations = {...this.searchFields.validations}
  },

  methods: {
    onClear(field) {
      this.$emit("handle-clear", field);
    },
    handleSearch() {
      let resultObject = {
        formResult: this.$refs.formSearch.onSearch()
      }
      this.$emit("handle-search", resultObject);
    },
  },
}
</script>

<style scoped>

</style>